/** Holds user global infos. */

// import _ from 'lodash'

/* let getUserPropHelper = (prop) => {
  let user = localStorage.getItem('user')
  let v = null
  if (user) {
    v = _.get(JSON.parse(user), prop)
  }
  return v
}

let getIndicatorPropHelper = (prop) => {
  let indicatorInfo = localStorage.getItem('indicatorInfo')
  let v = null
  if (indicatorInfo) {
    v = JSON.parse(indicatorInfo)
  }
  return v
} */

/** initial state */
/* const state = {
  clz: getUserPropHelper('clz'),
  firstLogin: getUserPropHelper('firstLogin'),
  institution: getUserPropHelper('institution'),
  institutionDepartment: getUserPropHelper('institutionDepartment'),
  menus: getUserPropHelper('menus'),
  name: getUserPropHelper('name'),
  role: getUserPropHelper('role'),
  school: getUserPropHelper('school'),
  schoolStage: getUserPropHelper('schoolStage'),
  firstNav: {},
  indicatorInfo: getIndicatorPropHelper('indicatorInfo'),
  level: getIndicatorPropHelper('level'),
  grade: getIndicatorPropHelper('grade')
} */
const state = {
  clz: null,
  firstLogin: null,
  institution: null,
  institutionDepartment: null,
  menus: null,
  name: null,
  role: null,
  school: null,
  schoolStage: null,
  firstNav: {},
  indicatorInfo: null,
  level: null,
  grade: null,
  loginTime: null,
  gradeString: null
}

/** actions */
const actions = {
}

const getters = {
  getMenu: (state) => () => {
    return state.menus
  },
  getFirstNav: (state) => () => {
    return state.firstNav
  },
  getSchoolStage: (state) => () => {
    return state.schoolStage
  },
  getFirstLogin: (state) => () => {
    return state.firstLogin
  },
  getIndicatorInfo: (state) => () => {
    return state.indicatorInfo
  },
  getLevel: (state) => () => {
    return state.level
  },
  getGrade: (state) => () => {
    return state.grade
  },
  getLoginTime: (state) => () => {
    return state.loginTime
  },
  getGradeString: (state) => {
    return state.gradeString
  }
}

/** mutations */
const mutations = {
  login (state, user) {
    state.clz = user.clz
    state.firstLogin = user.firstLogin
    state.institution = user.institution
    state.institutionDepartment = user.institutionDepartment
    state.menus = user.menus
    state.name = user.name
    state.role = user.role
    state.school = user.school
    state.schoolStage = user.schoolStage
    state.level = user.level
    state.grade = user.grade
    state.loginTime = user.loginTime
    state.gradeString = user.gradeString
    // localStorage.setItem('user', JSON.stringify(user))
  },

  firstNav (state, payload) {
    state.firstNav = payload
  },

  firstLogin (state, payload) {
    state.firstLogin = payload
  },

  indicator (state, payload) {
    state.indicatorInfo = payload
    // localStorage.setItem('indicatorInfo', JSON.stringify(payload))
  },

  logout (state) {
    Object.assign(state, {
      clz: null,
      firstLogin: null,
      institution: null,
      institutionDepartment: null,
      menus: null,
      name: null,
      role: null,
      school: null,
      schoolStage: null,
      firstNav: {},
      indicatorInfo: null,
      level: null,
      grade: null,
      loginTime: null,
      gradeString: null
    })
    window.localStorage.clear()
  }
}

/* export for using */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js